import { ChatGroupRoom } from './chatGroupRoom';
import { Member } from './member';

export enum GroupType {
    GROUP = 'ChatGroup::Group',
    INDIVIDUAL = 'ChatGroup::Individual',
    FREE = 'ChatGroup::Free',
}

export type ChatGroup = {
    id: number;
    type: GroupType;
    icon: string;
    name: string;
    members: Member[];
    chatRooms: ChatGroupRoom[];
};

export const getFriendIds = (groups: ChatGroup[], userId: number): number[] =>
    groups
        .filter((group) => group.type === GroupType.INDIVIDUAL)
        .flatMap((group) => group.members)
        .map((member) => member.id)
        .filter((id) => id !== userId);
